import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { LoadingService } from "../../services/loading.service";

@Component({
  selector: "app-loading-progress-bar",
  standalone: true,
  imports: [],
  templateUrl: "./loading-progress-bar.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loading-progress-bar.scss",
})
export class LoadingProgressBarComponent {
  protected loadingService = inject(LoadingService);
}
